export var HotelAvailabilityErrors;
(function (HotelAvailabilityErrors) {
    HotelAvailabilityErrors[HotelAvailabilityErrors["FLIGHT_ERROR"] = 0] = "FLIGHT_ERROR";
    HotelAvailabilityErrors[HotelAvailabilityErrors["FLIGHT_ERROR_NO_FLIGHT_ID"] = 1] = "FLIGHT_ERROR_NO_FLIGHT_ID";
    HotelAvailabilityErrors[HotelAvailabilityErrors["BASKET_ERROR"] = 2] = "BASKET_ERROR";
    HotelAvailabilityErrors[HotelAvailabilityErrors["ROOM_ERROR"] = 3] = "ROOM_ERROR";
    HotelAvailabilityErrors[HotelAvailabilityErrors["CONTINUE_TO_BOOK_ERROR"] = 4] = "CONTINUE_TO_BOOK_ERROR";
    HotelAvailabilityErrors[HotelAvailabilityErrors["CACHED_NAVL_ERROR"] = 5] = "CACHED_NAVL_ERROR";
    HotelAvailabilityErrors[HotelAvailabilityErrors["CHANGE_FLIGHT_ERROR"] = 6] = "CHANGE_FLIGHT_ERROR";
})(HotelAvailabilityErrors || (HotelAvailabilityErrors = {}));
